import React from "react";
import { TimesheetFull } from "../../../../components";

const TimesheetDashboard = () => {
  return (
    <div className="flex flex-1  overflow-hidden">
      <TimesheetFull />
    </div>
  );
};

export default TimesheetDashboard;
